import urlcat from 'urlcat';

export const generateURL = ({ path, baseUrl, params = {}, locale }) => {
  return urlcat(baseUrl, `/:locale${path}`, { locale, ...params });
};

// TODO: Once Coconut support locale in path can remove this function and use generateURL
export const generateURLWithoutLocale = ({ path, baseUrl, params = {} }) => {
  return urlcat(baseUrl, path, params);
};



// WEBPACK FOOTER //
// ./app/utils/navigation.js